module.exports = __webpack_public_path__ + "static/Yottaa-48a89fdbef2f02f8c2d77b182e5a2aac.svg";